const title = {
  id: 'stockOutIssueSuggestionsDialog.title',
};

const textIds = {
  title,
};

export default textIds;
